import React from 'react';
import { PhoneIcon } from 'lucide-react';
import { Logo } from './Logo';
export function SiteFooter() {
  return <footer className="bg-navy-deep pb-32 pt-16 text-paper md:pb-16" data-id="element-155" data-mp="3r9ar5krelu1u">
      <div className="mx-auto max-w-7xl px-6 md:px-10" data-id="element-156" data-mp="3mh9ie8tg2lgk">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-157" data-mp="3mfq24i7sgaes">
          <div data-id="element-158" data-mp="3hhwt7hf3p2at">
            <a href="/" aria-label="Veterans For Life home" className="inline-block" data-id="element-159" data-mp="3hgdehv93ezb5">
              <Logo data-id="element-160" data-mp="3di5zp5y6w82l" />
            </a>
            <p className="mt-5 text-lg text-paper/80" data-id="element-161" data-mp="38i1fp5y2ov7m">Veterans helping veterans.</p>
          </div>

          <div className="grid gap-8 sm:grid-cols-2 sm:gap-16" data-id="element-162" data-mp="33if0iqyop4w6">
            <nav aria-label="Footer" data-id="element-163" data-mp="33krhb0sph97n">
              <ul className="space-y-1" data-id="element-164" data-mp="2yk3s8ko1f2g2">
                <li data-id="element-165" data-mp="2yl53oq8ytqyb">
                  <a href="/faq" className="inline-flex min-h-[48px] items-center text-lg text-paper/90 transition-colors duration-150 ease-out hover:text-gold" data-id="element-166" data-mp="2ylopii1qkzhm">
                    FAQ
                  </a>
                </li>
                <li data-id="element-167" data-mp="15pk6r6rctnr9">
                  <a href="/contact-us" className="inline-flex min-h-[48px] items-center text-lg text-paper/90 transition-colors duration-150 ease-out hover:text-gold" data-id="element-168" data-mp="15t7z42l2c44e">
                    Contact Us
                  </a>
                </li>
              </ul>
            </nav>
            <address className="space-y-3 not-italic text-lg text-paper/90" data-id="element-169" data-mp="1oh38la9n6vrp">
              <p data-id="element-170" data-mp="1tg6esy1cz819">[PHONE]</p>
              <p data-id="element-171" data-mp="1tfeg3ecgsu6r">[EMAIL]</p>
            </address>
          </div>
        </div>

        <div aria-hidden="true" className="mt-12 h-px w-full bg-gold/30" data-id="element-172" data-mp="1es36vj3r9m9t" />

        <p className="mt-8 flex items-start gap-3 text-lg leading-relaxed text-paper" data-id="element-173" data-mp="1eppa95tfg205">
          <PhoneIcon aria-hidden="true" className="mt-1.5 h-5 w-5 shrink-0 text-gold" strokeWidth={1.75} data-id="element-174" data-mp="1jojso6nhfojq" />
          <span data-id="element-175" data-mp="27ee3kio8r31c">
            In crisis? Veterans Crisis Line: dial{' '}
            <a href="tel:988" aria-label="Call 988, the Veterans Crisis Line" className="-my-3 inline-block px-1 py-3 font-semibold text-paper underline decoration-gold decoration-2 underline-offset-4 transition-colors duration-150 ease-out hover:text-gold" data-id="element-176" data-mp="2c8igdik6u5ac">
              988
            </a>
            , then press 1. Free, confidential, 24/7.
          </span>
        </p>

        <p className="mt-6 max-w-4xl text-sm leading-relaxed text-paper/70" data-id="element-177" data-mp="2341w4u5dp615">
          Veterans For Life is a private company. We are not affiliated with, endorsed by, or accredited through the
          U.S. Department of Veterans Affairs. Free claims assistance is available through accredited Veterans
          Service Organizations.
        </p>
        <p className="mt-4 text-sm text-paper/60" data-id="element-178" data-mp="1pdyfqjt6k6jm">© {new Date().getFullYear()} Veterans For Life</p>
      </div>
    </footer>;
}